/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  Strucutre:
          url     => router path
          name    => name to display in sidebar
          slug    => router path name
          icon    => Feather Icon component/icon name
          tag     => text to display on badge
          tagColor  => class to apply on badge element
          i18n    => Internationalization
          submenu   => submenu of current item (current item will become dropdown )
                NOTE: Submenu don't have any icon(you can add icon if u want to display)
          isDisabled  => disable sidebar item/group
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
import con from "@/firebase/firebaseInit.ts";
import ls from "@/common/localStorage"

let ClientPlan = ls.getSessionValueByKey('ClientPlan');
ClientPlan = JSON.parse(ClientPlan);

let OnlyGeoCheckinModule = ls.getSessionValueByKey('UseOnlyGeoCheckinModule');
OnlyGeoCheckinModule = JSON.parse(OnlyGeoCheckinModule);

let checkinMenuItems = [{
    //isDisabled : (ls.getSessionValueByKey("Role") == 1 ? false : true),
    url: '/event/checkin-dashboard',
    name: 'checkindashboard',
    ParentMenuId: [0],
    RoleAccessId: [2,3],
    tagColor: 'warning',
    icon: 'MonitorIcon',
    i18n: 'Dashboard',
},
{
    url: '/event/attendees',
    name: 'checkinattendee',
    ParentMenuId: [0],
    RoleAccessId: [2,3],
    tagColor: 'warning',
    i18n: 'User Management',
    icon: 'UsersIcon'
},
{
    url: '/event/checkin/location',
    name: 'checkinlocation',
    ParentMenuId: [0],
    RoleAccessId: [2,3],
    slug: 'mailtpl-list',
    i18n: 'Location',
    icon: 'MapPinIcon'
},
{
    url: '/event/checkin/reports',
    name: 'checkinreports',
    ParentMenuId: [0],
    RoleAccessId: [2,3],
    slug: 'mailtpl-list',
    i18n: 'Reports',
    icon: 'BarChartIcon'
},
{
    url: '/event/checkin/settings',
    name: 'checkinsettings',
    ParentMenuId: [0],
    RoleAccessId: [2,3],
    slug: 'mailtpl-list',
    i18n: 'Settings',
    icon: 'SettingsIcon'
}]

let menuItems = [{
    //isDisabled : (ls.getSessionValueByKey("Role") == 1 ? false : true),
    url: '/client/list',
    name: 'clients',
    ParentMenuId: [0],
    RoleAccessId: [1],
    tagColor: 'warning',
    icon: 'UsersIcon',
    i18n: 'Clients',
    submenu: [{
        url: '/client/list',
        name: 'client-list',
        SubmenuId: 0,
        RoleAccessId: [1],
        slug: 'client-list',
        i18n: 'ClientList'
    }]
},
{
    url: '/mailtpl/list',
    name: 'mailtpl-list',
    ParentMenuId: [0],
    RoleAccessId: [1],
    slug: 'mailtpl-list',
    i18n: 'Mail Templates',
    icon: 'SidebarIcon'
},
{
    url: '/menu/list',
    name: 'menu-list',
    ParentMenuId: [0],
    RoleAccessId: [1],
    slug: 'menu-list',
    i18n: 'Menus',
    icon: 'SidebarIcon'
},
{
    url: '/tagscategpryins',
    name: 'tagscategpryinstance',
    ParentMenuId: [0],
    RoleAccessId: [1],
    slug: 'tagscategpryinstance',
    i18n: 'Tags Categpry Instance',
    icon: 'SidebarIcon'
},
{
    url: '/event/list',
    name: 'all-events',
    ParentMenuId: [0],
    RoleAccessId: [2, 3, 4],
    slug: 'all-events',
    icon: 'GridIcon',
    i18n: 'AllEvents'
},
{
    url: '/event/overview',
    name: 'overview',
    ParentMenuId: [-1],
    RoleAccessId: [2, 3],
    /*tag: '2',*/
    tagColor: 'warning',
    icon: 'PieChartIcon',
    i18n: 'overview'
},
{
    url: "/event/reg-dashboard",
    name: 'registration-dashboard',
    ParentMenuId: [-1],
    RoleAccessId: [2, 3, 4],
    slug: 'registration-dashboard',
    icon: 'ActivityIcon',
    i18n: 'Registration'
},
{
    url: null,
    name: 'Analytics',
    ParentMenuId: [1015, 1016],
    RoleAccessId: [2, 3, 4],
    slug: 'analytics',
    icon: 'TrendingUpIcon',
    i18n: 'Analytics',
    submenu: [{
        url: "/event/dashboard",
        name: 'event-dashboard',
        SubmenuId: 1016,
        RoleAccessId: [2, 3, 4],
        slug: 'event-dashboard',
        i18n: 'Dashboard'
    },
    {
        url: "/event/realtimedashboard",
        name: 'realtimedashboard',
        SubmenuId: 1016,
        RoleAccessId: [2, 3, 4],
        slug: 'realtimedashboard',
        i18n: 'Realtime Dashboard'
    },
    {
        url: "/event/expo-dashboard",
        name: 'exhibitor-dashboard',
        SubmenuId: 1016,
        RoleAccessId: [2, 3, 4],
        slug: 'exhibitor-dashboard',
        i18n: 'Exhibitor Dashboard'
    },
    {
        url: "/analytics/live-visitor",
        name: 'analytics-live-visitor',
        SubmenuId: 1019,
        RoleAccessId: [2, 3, 4],
        slug: 'analytics-live-visitor',
        i18n: 'AnalyticsLiveVisitor'
    },
    {
        url: "/analytics/user-login",
        name: 'analytics-user-login',
        SubmenuId: 1018,
        RoleAccessId: [2, 3, 4],
        slug: 'analytics-user-login',
        i18n: 'AnalyticsUserLogin'
    },
    {
        url: "/analytics/page-view",
        name: 'analytics-page-view',
        SubmenuId: 1016,
        RoleAccessId: [2, 3, 4],
        slug: 'analytics-page-view',
        i18n: 'AnalyticsEngagement'
    },
    {
        url: "/analytics/user-journey",
        name: 'analytics-user-journey',
        SubmenuId: 1017,
        RoleAccessId: [2, 3, 4],
        slug: 'analytics-user-journey',
        i18n: 'AnalyticsUserJourney'
    }
    ]
},
{
    url: null,
    name: 'event-setup',
    ParentMenuId: [0],
    RoleAccessId: [2, 3],
    slug: 'event-setup',
    icon: 'LayersIcon',
    i18n: 'EventSetup',
    submenu: [
        {
            url: '/event/edit',
            name: 'event-edit',
            SubmenuId: 0,
            RoleAccessId: [2, 3],
            slug: 'Basic Setup',
            i18n: 'Basic Setup'
        },
        {
            url: '/event/manage-menu',
            name: 'event-manage-menu',
            SubmenuId: 0,
            RoleAccessId: [2, 3],
            slug: 'Menu Options',
            i18n: 'Menu Options'
        },
        {
            url: '/event/floormaps',
            name: 'floormaps',
            SubmenuId: 0,
            RoleAccessId: [2, 3],
            slug: 'Floor Map',
            i18n: 'Floor Map'
        },
        {
            url: '/event/resources',
            name: 'resource',
            SubmenuId: 0,
            RoleAccessId: [2, 3],
            slug: 'Manage Resources',
            i18n: 'Manage Resources'
        },
    ]
},
{
    url: null,
    name: 'engagement',
    ParentMenuId: [0],
    RoleAccessId: [2, 3],
    slug: 'engagement',
    icon: 'CalendarIcon',
    i18n: 'Engagement',
    submenu: [
        {
            url: '/event/meetings',
            name: 'Meeting',
            SubmenuId: 0,
            RoleAccessId: [2, 3],
            slug: 'Meeting',
            i18n: 'Meeting'
        },
        {
            url: '/event/chatgroups',
            name: 'Chatgroups',
            SubmenuId: 0,
            RoleAccessId: [2, 3],
            slug: 'Live Chat',
            i18n: 'Live Chat'
        }, 
        {
            url: '/event/leaderboard',
            name: 'LeaderBoard',
            SubmenuId: 0,
            RoleAccessId: [2, 3],
            slug: 'Leader Board',
            i18n: 'Leader Board'
        }, 
        {
            url: '/event/gamification',
            name: 'Gamification',
            SubmenuId: 0,
            RoleAccessId: [2, 3],
            slug: 'Gamification',
            i18n: 'Gamification'
        },       
    ]
},
{
    url: null,
    name: 'notification',
    ParentMenuId: [0],
    RoleAccessId: [2, 3],
    slug: 'notification',
    icon: 'MessageCircleIcon',
    i18n: 'Notification',
    submenu: [
        {
            url: '/mailtpl/list',
            name: 'mailtpl-list',
            SubmenuId: 0,
            RoleAccessId: [2, 3],
            slug: 'mailtpl-list',
            i18n: 'Mail Templates'
        },
        {
            url: '/event/notification',
            name: 'notification',
            SubmenuId: 0,
            RoleAccessId: [2, 3],
            slug: 'Notification Center',
            i18n: 'Notification Center'
        },
    ]
},
{
    url: null,
    name: 'advance setup',
    ParentMenuId: [1001],
    RoleAccessId: [2, 3],
    slug: 'advanceSetup',
    icon: 'SlidersIcon',
    i18n: 'Advanced',
    submenu: [
        {
            url: '/event/custombranding',
            name: 'custom-branding',
            SubmenuId: 1001,
            RoleAccessId: [2, 3],
            slug: 'custom-branding',
            i18n: 'Custom Branding',
            ClientPlanRequired: ClientPlan && ClientPlan.ShowBrandingEventSetup ? true : false
        },{
            url: '/event/custompages',
            name: 'custompages',
            SubmenuId: 1001,
            RoleAccessId: [2, 3],
            slug: 'custompages',
            i18n: 'Custom Pages'
        }, {
            url: '/event/sessionmapping',
            name: 'sessionmapping',
            SubmenuId: 1001,
            RoleAccessId: [2, 3],
            slug: 'sessionmapping',
            i18n: 'Agenda Builder'
        }, {
            url: '/event/qnalist',
            name: 'qnalist',
            SubmenuId: 1001,
            RoleAccessId: [2, 3],
            slug: 'qnalist',
            i18n: 'QnA Moderation'
        }, {

            url: '/event/plugins',
            name: 'manage-plugins',
            SubmenuId: 1001,
            RoleAccessId: [2, 3],
            slug: 'manage-plugins',
            i18n: 'Manage Plugins'
        }, {

            url: '/event/checkin',
            name: 'checkinteam',
            SubmenuId: 1034,
            RoleAccessId: [2, 3],
            slug: 'checkinteam',
            i18n: 'Manage Checkin'
        },
    ]
},


{
    url: null,
    name: 'Reports',
    ParentMenuId: [1001],
    RoleAccessId: [2, 3],
    slug: 'Reports',
    icon: 'ClipboardIcon',
    i18n: 'Reports',
    submenu: [{
        url: '/report/businessCard',
        name: 'businessCard',
        SubmenuId: 1001,
        RoleAccessId: [2, 3],
        slug: 'businessCard',
        i18n: 'Business Card'
    }]
},
{
    url: null,
    name: 'forms',
    ParentMenuId: [1020],
    RoleAccessId: [2, 3],
    slug: 'forms',
    i18n: 'FormBuilders',
    icon: 'ServerIcon',
    submenu: [{
        url: '/form/list',
        name: 'form-list',
        SubmenuId: 1020,
        RoleAccessId: [2, 3],
        slug: 'form-list',
        i18n: 'FormBuilderList'
    }]
},
]


let menuClass = {
    Role: ls.getSessionValueByKey("Role"),
    Session_Client_Id: ls.getSessionValueByKey("Session_Client_Id"),
    cn: ls.getSessionEventCollectionName(),

    AvailableMenuIDss: async function () {
        let AvailableMenuIDs = []
        return await new Promise((resolve, reject) => {
            if (menuClass.Role == 1) {
                AvailableMenuIDs.push(0)
                resolve(AvailableMenuIDs)
            } else if (menuClass.cn) {
                //con.instanceDB.doc("ClientList").collection('Clients').doc(menuClass.Session_Client_Id).collection('Features').doc('ClientFeatures').get().then(function(features){
                con.eventDB.collection(menuClass.cn).doc('Features').get().then(function (features) {
                    let Features = (features.exists ? features.data().Features : [])
                    con.instanceDB.doc('Menu').get().then(function (menu) {
                        if (menu.exists) {
                            menu.data().AllMenu.forEach(menurow => {
                                let found = Features.some(el => el.ID === menurow.FeatureID && menurow.IsPublished);
                                if (found) {
                                    AvailableMenuIDs.push(menurow.MenuID)
                                }
                            })
                            resolve(AvailableMenuIDs)


                        } else {
                            resolve(AvailableMenuIDs)
                        }
                    })
                }).catch((err) => { reject(err) })
            } else {
                resolve(AvailableMenuIDs)
            }
            //return await AvailableMenuIDs
        })

    },

    getMenus: function () {
        let filterMenus = []
        //alert(menuItems[10].submenu.length)
        this.AvailableMenuIDss().then(function (AvailableMenuIDs) {

            //console.log(AvailableMenuIDs)
            if(OnlyGeoCheckinModule){
                for (let i = 0; i < checkinMenuItems.length; i++) {
                    let menu = checkinMenuItems[i]

                    let ParentMenuId = menu.ParentMenuId
                    let ParentRoleAccessId = menu.RoleAccessId
    
                    if (menu.submenu) {
                        let filtersubmenu = []
                        //console.log(menu.name + menu.submenu.length)
                        for (let j = 0; j < menu.submenu.length; j++) {
                            let submenu = menu.submenu[j]
                            let SubRoleAccessId = submenu.RoleAccessId
                            if (SubRoleAccessId.includes(parseInt(menuClass.Role))) {
                                if (submenu.SubmenuId == 0 && menuClass.cn) {
                                    if (submenu.ClientPlanRequired == undefined || submenu.ClientPlanRequired == true)
                                        filtersubmenu.push(submenu)
                                }
                                /*else if (submenu.SubmenuId == -1 && menuClass.cn && menuClass.Session_Client_Id == 'C1591205467009')
                                    filtersubmenu.push(submenu)*/
                                else {
                                    if (AvailableMenuIDs.includes(submenu.SubmenuId))
                                        filtersubmenu.push(submenu)
                                }
                            }
                        }
                        if (filtersubmenu.length) {
                            menu.submenuu = filtersubmenu
                            filterMenus.push(menu)
                        }
                    } else if (ParentMenuId.includes(-1) && ParentRoleAccessId.includes(parseInt(menuClass.Role)) && menuClass.cn) {
                        console.log("else if ====",menu);
                        filterMenus.push(menu)
                    } else {
                        if (ParentMenuId.includes(0) && ParentRoleAccessId.includes(parseInt(menuClass.Role))) {
                            console.log("else ====",menu);
                            filterMenus.push(menu)
                        }
                    }
    
                }
            }else{
                for (let i = 0; i < menuItems.length; i++) {
                    let menu = menuItems[i]
                    let ParentMenuId = menu.ParentMenuId
                    let ParentRoleAccessId = menu.RoleAccessId
    
                    if (menu.submenu) {
                        let filtersubmenu = []
                        //console.log(menu.name + menu.submenu.length)
                        for (let j = 0; j < menu.submenu.length; j++) {
                            let submenu = menu.submenu[j]
                            let SubRoleAccessId = submenu.RoleAccessId
                            if (SubRoleAccessId.includes(parseInt(menuClass.Role))) {
                                if (submenu.SubmenuId == 0 && menuClass.cn) {
                                    if (submenu.ClientPlanRequired == undefined || submenu.ClientPlanRequired == true)
                                        filtersubmenu.push(submenu)
                                }
                                /*else if (submenu.SubmenuId == -1 && menuClass.cn && menuClass.Session_Client_Id == 'C1591205467009')
                                    filtersubmenu.push(submenu)*/
                                else {
                                    if (AvailableMenuIDs.includes(submenu.SubmenuId))
                                        filtersubmenu.push(submenu)
                                }
                            }
                        }
                        if (filtersubmenu.length) {
                            menu.submenuu = filtersubmenu
                            filterMenus.push(menu)
                        }
                    } else if (ParentMenuId.includes(-1) && ParentRoleAccessId.includes(parseInt(menuClass.Role)) && menuClass.cn) {
                        filterMenus.push(menu)
                    } else {
                        if (ParentMenuId.includes(0) && ParentRoleAccessId.includes(parseInt(menuClass.Role))) {
                            filterMenus.push(menu)
                        }
                    }
    
                }
            }
        

        })
        return filterMenus

    },

    setEventCollectionName: function (cn) {
        this.cn = cn
    }



}




export default menuClass